import React from 'react'

function AlertBanner({ status, title, text, closeClicked }) {
  return (
    <div
      className={`alert alert-${status} u-decoBackgroundWhite u-paddingLeft4gu u-paddingVert3gu u-marginBottom1gu`}
      role="region"
      aria-label="Alert"
    >
      <div className={`u-flex u-flexAlignItemsCenter u-sizeConstrained`}>
        <p className="u-block u-flexAuto u-paddingLeft2gu u-paddingRight5gu">
          <b>{title}</b> {text}
        </p>
        <button
          type="button"
          onClick={closeClicked}
          className="alert-close-button"
          aria-label="Close"
        ></button>
      </div>
    </div>
  )
}

export default AlertBanner
